import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TableModule } from 'primeng/table';

import { MyTablesPageComponent } from './my-tables-page.component';
import { ViewTablesComponent } from './view-tables/view-tables.component';
import { ManageTablesComponent } from './manage-tables/manage-tables.component';
import { TableEditorComponent } from './create-tables/table-editor.component';
import { DatasetFieldComponent } from './create-tables/dataset-field/dataset-field.component';
import { MetricFieldComponent } from './create-tables/metric-field/metric-field.component';
import { TableViewComponent } from './table-view/table-view.component';

@NgModule({
  declarations: [
    MyTablesPageComponent,
    ViewTablesComponent,
    ManageTablesComponent,
    TableEditorComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    MatFormFieldModule,
    MatSelectModule,
    TableModule,
    DatasetFieldComponent,
    MetricFieldComponent,
    TableViewComponent
  ],
  exports: [
    MyTablesPageComponent
  ]
})
export class MyTablesPageModule { }
